import classNames from "classnames";
import React from "react";
import { Separator } from "../elements/Separator";
import {
  MainShortWidthClassName,
  MainWidthClassName,
  SectionPaddingClassName,
} from "../styles";

export const SectionIntro: React.FC<{
  title?: string | null;
  heading?: string | null;
  className?: string;
}> = ({ title, heading, className }) => {
  return (
    <section
      className={classNames(
        "bg-gradient-to-b from-hyacinth via-hyacinth-0",
        SectionPaddingClassName,
        className,
      )}
      data-component="Section Intro"
    >
      <div className="page-grid max-width relative auto-rows-max">
        {title && (
          <h3
            className={classNames(
              "h3 text-hyacinth",
              "mt-20px md:mt-40px",
              MainWidthClassName,
            )}
          >
            {title}
          </h3>
        )}
        {heading && (
          <h2
            className={classNames(
              "h1 mt-20px lg:mt-40px",
              MainShortWidthClassName,
            )}
          >
            {heading}
          </h2>
        )}
        <Separator className={classNames(MainWidthClassName)} />
      </div>
    </section>
  );
};
